import { render, staticRenderFns } from "./SmsTemplateManage.vue?vue&type=template&id=28d4ff43&scoped=true&"
import script from "./SmsTemplateManage.vue?vue&type=script&lang=js&"
export * from "./SmsTemplateManage.vue?vue&type=script&lang=js&"
import style0 from "./SmsTemplateManage.vue?vue&type=style&index=0&id=28d4ff43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4ff43",
  null
  
)

export default component.exports